import React from 'react';
import { Link, To } from 'react-router-dom';

interface TypeFillerProps {
  name: string;
  image: any;
  to: To;
  onImageError?: () => void;
}

const CategoryFilter: React.FC<TypeFillerProps> = ({ name, image, to, onImageError }) => {
  return (
    <Link to={to} className="category-filter-link">
      <div className="category-filter-content">
        <div className="category-image-container">
          <img
            src={image}
            alt={name}
            onError={onImageError}
            className="category-image"
          />
        </div>
        <p className="category-name">{name}</p>
      </div>
    </Link>
  );
};

export default CategoryFilter;